<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>院内协同</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>背景</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;">	对于三甲医院和医院集团，院内科室、专家办公室、实验室、病房、检查和检验等各个场所分布不同办公楼甚至院区，对于日常患者信息可视化多
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">学科会诊交流、学术研讨、办公会议、示教培训等都存在跨区域的沟通需求， 以提高沟通效率，节省医生、医务人员的时间，更多用于患者服务中。 
        </div>
        </div>
        <div class="header-second" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;">	平台提供针对院内各个科室和场所的统一视频协同平台，打通科室、医生办公室、病房、手术室、检查检验室、实验室、会议室和示教室等， 让可
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">视化沟通随时随地无处不在。 根据不同场景需求，提供针对性的软硬件终端方案，一键开机即用，方便用户操作。 系统支持与院内的HIS、Pacs、LIS等
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">系统集成，实现各个科室的多学科快速协同。 同时该平台支持混合云部署，对于医院外部的医联体医院，并可以与医院的互联网医院结合，打通患者和院 </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">内医生。</div>
            <div style="margin-top:25px;">
                <img src="@/assets/image/yuannei.png" alt="">
            </div>
        </div>
        <div class="header-firth" style="margin-top:15px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案框架</span></div>
            <div style="margin-top:20px">
                <img src="@/assets/image/yuannei1.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>